import React from 'react';

const CanvasIcon = () => {
  return (
    <svg width="35" height="59" viewBox="0 0 35 59" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 8.87724L29.9184 3.19775V57.016L2 53.3551V8.87724Z"
        stroke="#383838"
        strokeWidth="2.18732"
        strokeLinejoin="round"
      />
      <path
        d="M3.26611 9.59545L32.3819 2V56.1946"
        stroke="#383838"
        strokeWidth="3.98093"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
    </svg>
  );
};

export default CanvasIcon;
